import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

import { setConfirmPasscodeModalVisibility, handleVerifyPasscodeResult } from '../../actions/baseModal_actions';
import VerifyPasscodeModal from '../Common/VerifyPasscodeModal';

const propTypes = {
  visibility: PropTypes.bool.isRequired,
  setConfirmPasscodeModalVisibility: PropTypes.func.isRequired,
  handleVerifyPasscodeResult: PropTypes.func.isRequired,
};

const defaultProps = {
  // visibility: false,
  // setConfirmPasscodeModalVisibility: () => { },
  // handleVerifyPasscode: () => { },
};

class BaseModals extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <div>
        <SkyLightStateless
          dialogStyles={{}}
          isVisible={this.props.visibility}
          onCloseClicked={this.props.setConfirmPasscodeModalVisibility}
        >
          <VerifyPasscodeModal
            closeConfirm={this.props.handleVerifyPasscodeResult}
            text={<Translate value="passcode_confirm_text" />}
          />
        </SkyLightStateless>
      </div>
    )
  }
}


function mapState(state) {
  return {
    visibility: state.baseModals.confirmPasscodeModal.visibility,
  };
}

const mapActions = {
  setConfirmPasscodeModalVisibility,
  handleVerifyPasscodeResult,
};

BaseModals.propTypes = propTypes;
BaseModals.defaultProps = defaultProps;
export default connect(mapState, mapActions)(BaseModals);



// WEBPACK FOOTER //
// ./master/jsx/components/Layout/baseModals.jsx